(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-text.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-text.js');
'use strict';

const {
  IconMessage
} = svs.tb_ui_react.icon_message;
const {
  emailStatuses
} = svs.myProfile.constants;
const BOUNCED_REMOVED = 'Vi har inte kunnat nå din tidigare angivna e-post. Vänligen ange en ny adress.';
const BOUNCED_EXISTS = 'Vi har problem att nå e-postadressen du har angivit. Var vänlig kontrollera att adressen är korrekt och att din inkorg inte är full.';
const NOT_VERIFIED = 'Din e-post är obekräftad.';
const NOT_FOUND = 'E-post saknas';

const EmailText = () => {
  const {
    email,
    emailStatus
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings.playerCustomizedSettings);
  const isEmailBounced = emailStatus === emailStatuses.BOUNCE;
  const isEmailExists = Boolean(email);
  const emailVerified = "".concat(emailStatus) === emailStatuses.VERIFIED;
  let text = NOT_VERIFIED;
  if (isEmailExists) {
    if (isEmailBounced) {
      text = BOUNCED_EXISTS;
    }
  } else if (isEmailBounced) {
    text = BOUNCED_REMOVED;
  } else {
    text = NOT_FOUND;
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "overflow-threedots"
  }, email === null || email === void 0 ? void 0 : email.toLowerCase()), !emailVerified && React.createElement(IconMessage, {
    className: email ? 'padding-top-1' : ''
  }, text));
};
svs.myProfile.react.pages.myInformation.myInformation.email.EmailText = EmailText;

 })(window);